import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Chip,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Stack,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../shared/utils/Button";
import axios from "axios";

const DeletedStoreModal = ({
  open,
  onClose,
  deletedStores = [],
  FetchDetails,
  handleDeletedStores,
}) => {
  let serverURL = process.env.REACT_APP_URL;

  const groupedStores = Object.values(
    deletedStores.reduce((acc, item) => {
      const key = `${item.storeName}_${item.city}_${item.state}_${item.storeOwnerPhoneNumber}`;

      if (!acc[key]) {
        acc[key] = {
          ...item,
          products: [],
        };
      }

      acc[key].products.push(item.productId);

      return acc;
    }, {}),
  );

  const handleUndo = async (productId) => {
    let productIds = productId.map((ele) => ele._id);
    try {
      const response = await axios.post(
        `${serverURL}/jobs/undoDeletedStore`,
        {
          productIds,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.data.success) {
        handleDeletedStores();
        FetchDetails();
      }
    } catch (error) {}
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        Deleted Stores ({groupedStores.length})
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 10,
            top: 10,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Store</TableCell>
              <TableCell>Owner</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Restore</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {groupedStores.map((item) => (
              <TableRow key={item._id}>
                <TableCell>
                  <Typography fontWeight={600}>{item.storeName}</Typography>
                </TableCell>

                <TableCell>
                  <Stack spacing={0.5}>
                    <Typography>{item.storeOwnerName}</Typography>

                    <Typography variant="caption" color="text.secondary">
                      {item.storeOwnerPhoneNumber}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Tooltip
                    title={item.products.map((p) => p.productType).join(", ")}
                  >
                    <span>
                      {item.products[0]?.productType}

                      {item.products.length > 1 && (
                        <Chip
                          size="small"
                          label={`+${item.products.length - 1}`}
                        />
                      )}
                    </span>
                  </Tooltip>
                </TableCell>

                <TableCell>
                  {item.city}, {item.state}
                </TableCell>

                <TableCell>₹{item.paymentAmount || 0}</TableCell>

                <TableCell>
                  <Chip label="Deleted" color="error" size="small" />
                </TableCell>

                <TableCell>
                  <CustomButton
                    text="Yes"
                    onClick={() => handleUndo(item.products)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {!deletedStores?.length && (
          <Typography align="center" sx={{ py: 5 }}>
            No deleted stores found
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DeletedStoreModal;
